export default {
  title: "Game selection",
  forNewbies: "For newbies",
  forExperts: "For experts",
};
